import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-invalid-sku.dialog',
  standalone: false,
  templateUrl: './invalid-sku.dialog.component.html',
  styleUrl: './invalid-sku.dialog.component.scss'
})
export class InvalidSkuDialogComponent {}
